export default "__VITE_ASSET__DCU5CvYW__"